import React from 'react';
import {createRoot} from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import App from './App.tsx';
import './index.css';
import i18n from './i18n';

const ThemedApp = ThemeProvider as React.FC<{ attribute: string; defaultTheme: string; enableSystem: boolean; children: React.ReactNode }>;

// Static previews keep a semantic fallback for no-JS access. Remove it before
// mounting the single interactive page. There is no separate visual hero.
// remove() (not innerHTML) keeps React's own mount point untouched.
document.getElementById('seo-fallback')?.remove();

// High-prestige Console Signature & Self-XSS Defense
if (typeof window !== 'undefined') {
  try {
    console.log(
      '%c⚡ FLASH WEB RENNES %cv2.4 %cStudio Digital & Ingénierie Web',
      'background: #c8372d; color: white; font-weight: 800; font-size: 13px; padding: 4px 8px; border-radius: 4px;',
      'background: #18181b; color: #a1a1aa; font-size: 11px; padding: 4px 6px; margin: 0 4px; border-radius: 4px; border: 1px solid #27272a;',
      'color: #94a3b8; font-size: 11px; font-style: italic;'
    );
    console.log(
      '%c🛡️ Sécurité & Architecture : %cInfrastructure blindée, chiffrement TLS de pointe, protection CSRF/SSRF et données sensibles isolées côté serveur.',
      'color: #10b981; font-weight: bold; font-size: 11px;',
      'color: #cbd5e1; font-size: 11px;'
    );
    console.log(
      '%c💼 Projet web ou opportunité ? %cDiscutons de votre vision : https://flashwebrennes.online/contact',
      'color: #38bdf8; font-weight: bold; font-size: 11px;',
      'color: #94a3b8; font-size: 11px;'
    );
    console.log(
      '%c⚠️ Protection Self-XSS : %cNe collez aucun code ou script non vérifié dans cette console.',
      'color: #f59e0b; font-weight: bold; font-size: 11px;',
      'color: #94a3b8; font-size: 11px;'
    );

    (window as any).flashweb = {
      agency: 'Flash Web Rennes',
      tagline: 'Studio Digital & Ingénierie SEO Haute Performance',
      stack: ['React 19', 'TypeScript', 'Tailwind CSS', 'Vite', 'Node.js', 'Express', 'MySQL'],
      status: '🟢 All systems operational',
      contact: () => { window.location.href = '/contact'; return 'Redirection vers la page Contact...'; },
      audit: (url?: string) => { 
        const target = url ? `/audit?url=${encodeURIComponent(url)}` : '/audit';
        window.location.href = target;
        return `Lancement du scanner pour ${url || 'votre site'}...`;
      }
    };
  } catch (_) {}
}

createRoot(document.getElementById('root')!).render(
  <ThemedApp attribute="class" defaultTheme="dark" enableSystem={false}>
    <App />
  </ThemedApp>,
);
